import React, { useEffect, useRef } from 'react';
import IconToastSuccess from '@pano-project/assets/icons/icon-toast-success';
import IconClose from '@pano-project/assets/icons/IconClose.js';
import ErrorIcon from '@pano-project/assets/icons/error-icon';

export type ToastVariant = 'success' | 'error' | 'warning' | 'info';

export interface ToastProps {
  message: string;
  variant?: ToastVariant;
  duration?: number; // ms, 0 = persistent
  onClose?: () => void;
  visible?: boolean;
  className?: string;
}

const Toast: React.FC<ToastProps> = ({
  message,
  variant = 'info',
  duration = 3000,
  onClose,
  visible = true,
  className = '',
}) => {
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!visible || duration <= 0) return;
    const timer = setTimeout(() => onCloseRef.current?.(), duration);
    return () => clearTimeout(timer);
  }, [visible, duration]);

  if (!visible) return null;

  const getIcon = () => {
    switch (variant) {
      case 'error':
        return <ErrorIcon className="pano-toast__icon" />;

      default:
        return <IconToastSuccess className="pano-toast__icon" />;
    }
  };

  return (
    <div className={`pano-toast pano-toast--${variant} ${className}`}>
      {getIcon()}
      <span className="pano-toast__message">{message}</span>
      {onClose && (
        <button className="pano-toast__close" onClick={onClose} aria-label="Close">
          <IconClose className="pano-toast__close-icon" color="var(--neutral_active)" />
        </button>
      )}
    </div>
  );
};

export default Toast;
